<!--面板组件-->

<template>
  <div>
    <el-form :model="formData" ref="formData">
      <div v-for="(domain, index) in formData.formArr" :key="domain.key">
        <div class="header">
          <div class="box_title">Signatory {{ index + 1 }}</div>
          <div
            class="box_remove"
            v-show="formData.formArr.length !== 1"
            @click="doRemove(index)"
          >
            Remove
          </div>
        </div>
        <div class="input_area">
          <el-form-item
            :label="'Full Name of Signatory'"
            :prop="`formArr[${index}]`"
            class="aaa"
            :rules="[{
              required: true,
              message: 'Full Name of Signatory is error',
              trigger: ['blur','change'],
            },{
              pattern: /^[a-zA-Z0-9 ]*$/,
              message: 'Use numbers and letters only.',
              trigger: ['blur','change'],
            }]"
          >
            <el-input
              v-model="formData.formArr[index]"
              placeholder="First Name, M.I., Last Name"
              maxlength="32"
              clearable
            ></el-input>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <div class="box_add">
      <div
        class="addContent"
        @click="doAdd()"
        v-show="formData.formArr.length !== 5"
      >
        + Add Another Signatory
      </div>
    </div>
  </div>
</template>


<script>
// import API from "@/api";

export default {
  name: "Signatory",
  components: {},
  data() {
    return {
      formData: {
        formArr: [''],
      },
    };
  },
  methods: {
    doRemove(index) {
      if (this.formData.formArr.length > 1) {
        this.formData.formArr.splice(index, 1);
      }
    },
    doAdd() {
      if (this.formData.formArr.length < 5) {
        this.formData.formArr.push('');
      }
    },
    updateDataForm(val){
      this.formData.formArr = val.businessauthorized
    },
  },
  // props: ["baseData"],
};
</script>

<style lang="scss" scoped>
.header {
  width: 766px;
  font-family: Nunito;
  font-size: 16px;
  display: flex;
  // justify-content: space-between;
  .box_title {
    color: #004ea8;
    font-family: Nunito-bold;
    margin-bottom: 10px;
  }
  .box_remove {
    margin-left:200px ;
    color: #0072d8;
    cursor: pointer;
  }
}
.box_add {
  display: flex;
  flex-direction: row-reverse;
  width: 48%;
  margin-bottom: 20px;
  .addContent {
    color: #0072d8;
    text-decoration: underline;
    cursor: pointer;
  }
}
.input_area {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>
